<div class="flex h-screen flex-col">
  <div class="p-md flex w-full flex-col">
    <span class="text-content-secondary">{{ aptitude()?.nom }}</span>
    <div class="flex w-full justify-between">
      <span class="title-small-semibold">{{ production().nom }}</span>
      <app-chip [label]="production().ressources.length | i18nPlural: ressourceMapping" />
    </div>
  </div>
  <hlm-separator />
  <div class="p-md overflow-y-auto">
    @if (peutModifier()) {
      <button class="mb-md" (click)="ajouterRessourceProfessionnelle()" hlmBtn variant="secondary">
        <ng-icon name="lucidePlus" />
        Ajouter une ressource professionnelle
      </button>
    }
    <div class="gap-sm flex flex-col">
      @for (type of ressourceTypes; track $index) {
        <app-expansion-panel [titre]="type + 's'">
          <ng-icon
            class="!text-components-content-neutral-secondary mr-xs"
            [name]="getIcon(type)"
            hlm
            size="sm"
            cardItemIcon
            ngProjectAs="iconLeft"
          />
          <div ngProjectAs="chipRight">
            <app-chip [label]="getRessourcesFiltrees(type).length" size="badge" />
          </div>
          <div class="p-md gap-md flex flex-col">
            @if (peutModifier()) {
              <button class="w-fit" (click)="ajouterRessourceProfessionnelle(type)" hlmBtn variant="secondary">
                <ng-icon name="lucidePlus" /> Ajouter
                {{ (type !== 'Matériel' ? 'une ' : 'un ') + (type | lowercase) }}
              </button>
            }
            <div
              class="gap-xs grid"
              [cdkDropListData]="getRessourcesFiltrees(type)"
              (cdkDropListDropped)="dropRessource($event)"
              cdkDropList
              cdkDropListGroup
            >
              @for (ressource of getRessourcesFiltrees(type); track $index) {
                <app-ressource-professionnelle-item
                  [cartographie]="cartographie()"
                  [production]="production()"
                  [ressource]="ressource"
                  [peutModifier]="peutModifier()"
                />
              } @empty {
                <p class="text-content-secondary paragraph-medium-medium">
                  {{ (type !== 'Matériel' ? 'Aucune ' : 'Aucun ') + (type | lowercase) + ` n'a été ajouté` + (type !== 'Matériel' ? 'e' : '')}}
                </p>
              }
            </div>
          </div>
        </app-expansion-panel>
      }
    </div>
  </div>
</div>
